import { Button, Card, CardHeader, CardContent, Typography } from '@mui/material';
import { GuardedComponent } from '../../../components/guarded-component';
import { UserPermissionName } from '../../../models/user-permission-name';

const styling = {
  root: { paddingRight: '15px', paddingBottom: '10px' },
  paperStyle: { padding: '20px', borderRadius: '20px' },
  headingStyle: { fontWeight: 'bold' },
  buttonStyle: { width: '130px' },
  linkStyle: {
    color: '#5D6D7E',
    textDecoration: 'none',
  },
};

interface SetupButtonsPage {
  openNoteDialog: () => void;
}

export const SetupButtons = ({ openNoteDialog }: SetupButtonsPage) => {
  return (
    <Card elevation={0}>
      <CardHeader
        className="subHead"
        title={
          <Typography variant="h3" color="textPrimary" style={styling.headingStyle}>
            SETUP
          </Typography>
        }
      ></CardHeader>
      <CardContent className="formContainer">
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_NOTE]}>
          <Button variant="outlined" onClick={openNoteDialog}>
            NOTES
          </Button>
        </GuardedComponent>
      </CardContent>
    </Card>
  );
};
